import { render } from "./EyeQuestionView.vue?vue&type=template&id=474b1a16"
import script from "./EyeQuestionView.vue?vue&type=script&lang=js"
export * from "./EyeQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__